// Ink, the AI teacher, for the waitlist page: the human Ink of the videos (video/src/podcast/Person.tsx, without
// headphones), looking a little to her right. Every motion is CSS in waitlist.css: she blinks, breathes, tilts her
// head, talks (.talk over .rest) and lifts her near hand (.arm-up over .arm-rest). `part` draws her in two layers,
// so the hero's card can sit between her body and her hands; `wave` raises her hand to wave, at her desk.
const SKIN = '#C98B62';
const HAIR = '#2B1E1A';
const TOP = '#F2B035';

export function InkFigure({ part = 'all', wave = false }: { part?: 'all' | 'body' | 'arms'; wave?: boolean }) {
  const body = (
    <>
      <g className="torso">
        <path d="M-54 130 C-54 68 -42 46 -15 41 L15 41 C42 46 54 68 54 130 Z" fill={TOP} />
        <path d="M-54 130 C-54 90 -50 70 -40 58" stroke="rgba(0,0,0,.08)" strokeWidth="6" fill="none" />
        <path d="M-15 42 L0 68 L15 42 Z" fill="#FFF6E5" />
        <path d="M-15 42 L0 68 M15 42 L0 68" stroke="rgba(0,0,0,.16)" strokeWidth="1.5" />
        <circle cx="-7" cy="76" r="1.8" fill="rgba(0,0,0,.18)" />
        <circle cx="-7" cy="86" r="1.8" fill="rgba(0,0,0,.18)" />
        <rect x="-8.5" y="25" width="17" height="20" fill={SKIN} />
        <rect x="-8.5" y="25" width="17" height="7" fill="rgba(0,0,0,.12)" />
      </g>
      {/* The head tilts around the neck. */}
      <g transform="translate(0 28)">
        <g className="tilt">
          <g transform="translate(0 -28)">
            <circle cx="5" cy="-39" r="14" fill={HAIR} />
            <ellipse cx="0" cy="-3" rx="34.5" ry="37" fill={HAIR} />
            <circle cx="-29.5" cy="4" r="6.5" fill={SKIN} />
            <circle cx="29.5" cy="4" r="6.5" fill={SKIN} />
            <circle cx="-30" cy="12" r="2.4" fill={TOP} />
            <circle cx="30" cy="12" r="2.4" fill={TOP} />
            <ellipse cx="0" cy="0" rx="30" ry="34" fill={SKIN} />
            <ellipse cx="0" cy="22" rx="20" ry="10" fill="rgba(0,0,0,.035)" />
            <circle cx="-15.7" cy="12" r="4.8" fill="#F08A7A" opacity="0.37" />
            <circle cx="18.3" cy="12" r="4.8" fill="#F08A7A" opacity="0.37" />
            <g className="eyes">
              <ellipse cx="-9.7" cy="2" rx="3.6" ry="4.4" fill="#1B1C20" />
              <ellipse cx="12.3" cy="2" rx="3.6" ry="4.4" fill="#1B1C20" />
              <circle cx="-8.5" cy="0.2" r="1.2" fill="#FFF" />
              <circle cx="13.5" cy="0.2" r="1.2" fill="#FFF" />
            </g>
            <path
              d="M-14.7 -10 Q-9.7 -12.5 -4.7 -10 M7.3 -10 Q12.3 -12.5 17.3 -10"
              stroke={HAIR}
              strokeWidth="2.6"
              fill="none"
              strokeLinecap="round"
            />
            <path d="M2.3 5 q3 4 -1 6" stroke="rgba(0,0,0,.22)" strokeWidth="1.7" fill="none" strokeLinecap="round" />
            <g className="rest">
              <path d="M-7.46 13.6 Q1.04 25 9.54 13.6 Q1.04 16 -7.46 13.6 Z" fill="#6E2A2A" />
              <path
                d="M-4.96 15.4 Q1.04 16.6 7.04 15.4"
                stroke="#FFF"
                strokeOpacity=".9"
                strokeWidth="1.6"
                fill="none"
              />
            </g>
            <g className="talk">
              <g className="jaw">
                <path d="M-7.46 14 Q1.04 28 9.54 14 Q1.04 16.4 -7.46 14 Z" fill="#6E2A2A" />
                <ellipse cx="1.04" cy="21.5" rx="4.2" ry="2.4" fill="#E07A6E" />
                <path d="M-4.96 15.6 Q1.04 16.8 7.04 15.6" stroke="#FFF" strokeWidth="1.6" fill="none" opacity=".9" />
              </g>
            </g>
            <path
              d="M-31 -5 C-29 -30 -8 -39 6 -37 C22 -35 32 -22 31 -6 C22 -21 6 -25 -10 -19 C-19 -16 -26 -11 -31 -5 Z"
              fill={HAIR}
            />
            <g stroke="#17181B" strokeWidth="1.9" fill="none">
              <rect x="-17.72" y="-5" width="15" height="12.5" rx="5" />
              <rect x="4.28" y="-5" width="15" height="12.5" rx="5" />
              <path d="M-2.72 0 h7 M-18.5 -1 L-28 -3 M18.5 -1 L28 -3" />
            </g>
          </g>
        </g>
      </g>
    </>
  );
  const desk = (
    <>
      <rect x="-76" y="96" width="152" height="30" fill="#E7D7BC" />
      <rect x="-80" y="86" width="160" height="15" rx="7.5" fill="#C99A68" />
      <rect x="-78" y="87.3" width="156" height="4.5" rx="2.25" fill="#DDB283" />
    </>
  );
  const arms = (
    <>
      <path d="M-44 58 Q-56 85.5 -26 85" stroke={TOP} strokeWidth="17" fill="none" strokeLinecap="round" />
      <ellipse cx="-26" cy="85" rx="9.5" ry="8" fill={SKIN} />
      {wave ? (
        // The waving arm swings around the shoulder.
        <g transform="translate(44 58)">
          <g className="wave">
            <g transform="translate(-44 -58)">
              <path d="M44 58 Q72 53 58 20" stroke={TOP} strokeWidth="17" fill="none" strokeLinecap="round" />
              <ellipse cx="58" cy="20" rx="9.5" ry="8" fill={SKIN} />
            </g>
          </g>
        </g>
      ) : (
        <>
          <g className="arm-rest">
            <path d="M44 58 Q56 85.5 26 85" stroke={TOP} strokeWidth="17" fill="none" strokeLinecap="round" />
            <ellipse cx="26" cy="85" rx="9.5" ry="8" fill={SKIN} />
          </g>
          <g className="arm-up">
            <path d="M44 58 Q62 68.5 51 51" stroke={TOP} strokeWidth="17" fill="none" strokeLinecap="round" />
            <ellipse cx="51" cy="51" rx="9.5" ry="8" fill={SKIN} />
          </g>
        </>
      )}
    </>
  );
  return (
    <svg className={`wl-person ${part}`} viewBox="-80 -58 160 166" aria-hidden="true">
      {part !== 'arms' && body}
      {part === 'all' && desk}
      {part !== 'body' && arms}
    </svg>
  );
}
